import {getProductList,getProductType,delProduct,getProduct,addProduct,getGroupList} from '@/api/api'

const state = {
    productData:{
    },
    productDetail:{},
    productType:[],
    groupData:{},
    groupDetail:{},
};
const getters = {
    getPro:function (state) {
        return state.productData
    },
    getProDetail:function (state) {
        return state.productDetail
    },
    getProductType:function (state) {
        return state.productType
    },
    getGroup:function (state) {
        return state.groupData
    },
    getGroupDetail:function (state) {
        return state.groupDetail
    },
};

const actions = {
    initProList({commit,state},param){
        return new Promise((resolve) => {
            getProductList(param).then((res) => {
                commit('INIT_PROLIST',res.data);
                resolve(res)
            })
        })
    },
    initProDetail({commit,state},param){
        console.log(state.productData.list)
        if(state.productData.list){
            state.productData.list.forEach(function (item,index) {
                if(param == item.proId){
                    commit('INIT_PRODETAIL',item)
                }
            })
        }else{
            window.history.go(-1)
        }
    },
    initProductType({commit,state},param){
        getProductType(param).then((res) => {
            commit('INIT_PRODUCTTYPE',res.data);
        })
    },
    initGroupList({commit,state},param){
        return new Promise((resolve) => {
            getGroupList(param).then((res) => {
                commit('INIT_GROUPLIST',res.data);
                resolve(res)
            })
        })
    },
    initGroupDetail({commit,state},param){
        if(state.groupData.list){
            state.groupData.list.forEach(function (item,index) {
                if(param == item.groupId){
                    commit('INIT_GROUPDETAIL',item)
                }
            })
        }else{
            window.history.go(-1)
        }
    },
};
let mutations = {
    INIT_PROLIST(state,param){
        state.productData = param
    },
    INIT_PRODETAIL(state,param){
        state.productDetail = param
    },
    INIT_PRODUCTTYPE(state,param){
        state.productType = param
    },
    INIT_GROUPLIST(state,param){
        state.groupData = param
    },
    INIT_GROUPDETAIL(state,param){
        state.groupDetail = param
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/productList.js